import { brandsActions } from '../reducer';

type Operation = () => void;

export const resetDeleteFavouriteBrandsStatus: Operation = () => brandsActions
  .resetDeletingStatus();
